// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-student-demo[data-v-51faf042]{box-shadow:0 5px 10px rgba(34,34,34,.25);border:1px solid #dcdee0}`, "",{"version":3,"sources":["webpack://./assets/src/scripts/components/routes/article-tabs/book-of-knowledge.vue"],"names":[],"mappings":"AAEA,oCACC,wCAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
